module.exports = __webpack_public_path__ + "static/img/shl_small_baskeball_note_2.01e7d74.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shl_small_baskeball_note_2.png
// module id = sZwT
// module chunks = 5